export default __webpack_public_path__ + "static/media/franchise-template-2.8d3df178.svg";